const readMore = () => {
  /*!
   * @preserve
   *
   * Readmore.js jQuery plugin
   * Author: @jed_foster
   * Project home: http://jedfoster.github.io/Readmore.js
   * Licensed under the MIT license
   *
   * Debounce function from http://davidwalsh.name/javascript-debounce-function
   */

  /* global jQuery */

  (function ($) {
    const readmore = 'readmore';
    const defaults = {
      speed: 100,
      collapsedHeight: 200,
      heightMargin: 16,
      moreLink: '<a href="#">Read More</a>',
      embedCSS: true,
      blockCSS: 'display: block; width: 100%;',
      startOpen: false,

      // callbacks
      beforeToggle() {},
      afterToggle() {},
    };
    const cssEmbedded = {};
    let uniqueIdCounter = 0;

    function debounce(func, wait, immediate) {
      let timeout;

      return function () {
        const context = this;
        const args = arguments;
        const later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };
        const callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
          func.apply(context, args);
        }
      };
    }

    function uniqueId(prefix) {
      const id = ++uniqueIdCounter;

      return String(prefix == null ? 'rmjs-' : prefix) + id;
    }

    function setBoxHeights(element) {
      const el = element
        .clone()
        .css({
          height: 'auto',
          width: element.width(),
          maxHeight: 'none',
          overflow: 'hidden',
        })
        .insertAfter(element);
      const expandedHeight = el.outerHeight();
      const cssMaxHeight = parseInt(
        el
          .css({ maxHeight: '' })
          .css('max-height')
          .replace(/[^-\d\.]/g, ''),
        10,
      );
      const defaultHeight = element.data('defaultHeight');

      el.remove();

      let collapsedHeight = element.data('collapsedHeight') || defaultHeight;

      if (!cssMaxHeight) {
        collapsedHeight = defaultHeight;
      } else if (cssMaxHeight > collapsedHeight) {
        collapsedHeight = cssMaxHeight;
      }

      // Store our measurements.
      element
        .data({
          expandedHeight,
          maxHeight: cssMaxHeight,
          collapsedHeight,
        })
        // and disable any `max-height` property set in CSS
        .css({
          maxHeight: 'none',
        });
    }

    const resizeBoxes = debounce(function () {
      $('[data-readmore]').each(function () {
        const current = $(this);
        const isExpanded = current.attr('aria-expanded') === 'true';

        setBoxHeights(current);

        current.css({
          height: current.data(
            isExpanded ? 'expandedHeight' : 'collapsedHeight',
          ),
        });
      });
    }, 100);

    function embedCSS(options) {
      if (!cssEmbedded[options.selector]) {
        let styles = ' ';

        if (options.embedCSS && options.blockCSS !== '') {
          styles += `${options.selector} + [data-readmore-toggle], ${
            options.selector
          }[data-readmore]{${options.blockCSS}}`;
        }

        // Include the transition CSS even if embedCSS is false
        styles +=
          `${options.selector}[data-readmore]{` +
          `transition: height ${options.speed}ms;` +
          `overflow: hidden;` +
          `}`;

        (function (d, u) {
          const css = d.createElement('style');
          css.type = 'text/css';

          if (css.styleSheet) {
            css.styleSheet.cssText = u;
          } else {
            css.appendChild(d.createTextNode(u));
          }

          d.getElementsByTagName('head')[0].appendChild(css);
        })(document, styles);

        cssEmbedded[options.selector] = true;
      }
    }

    function Readmore(element, options) {
      const $this = this;

      this.element = element;

      this.options = $.extend({}, defaults, options);

      embedCSS(this.options);

      this._defaults = defaults;
      this._name = readmore;

      this.init();

      // Need to resize boxes when the page has fully loaded.
      window.addEventListener('load', resizeBoxes);

      window.addEventListener('resize', resizeBoxes);
    }

    Readmore.prototype = {
      init() {
        const $this = this;
        const current = $(this.element);

        current.data({
          defaultHeight: this.options.collapsedHeight,
          heightMargin: this.options.heightMargin,
        });

        setBoxHeights(current);

        const collapsedHeight = current.data('collapsedHeight');
        const heightMargin = current.data('heightMargin');
        const expandedHeight = current.data('expandedHeight');

        if (expandedHeight <= collapsedHeight + heightMargin) {
          // The block is shorter than the limit, so there's no need to truncate it.
          return true;
        }
        const id = current.attr('id') || uniqueId();
        const useLink = $this.options.startOpen
          ? $this.options.lessLink
          : $this.options.moreLink;

        current.attr({
          'data-readmore': '',
          'aria-expanded': false,
          id,
        });

        current.after(
          $(useLink)
            .on('click', function (event) {
              $this.toggle(this, current[0], event);
            })
            .attr({
              'data-readmore-toggle': '',
              'aria-controls': id,
            }),
        );

        if (!$this.options.startOpen) {
          current.css({
            height: collapsedHeight,
          });
        }

        if (window.template_type == 'blog') {
          const textContent = current.text();
          const words = textContent.split(' ');
          const truncatedText = words.slice(0, 30).join(' ');
          current.text(`${truncatedText}...`);
        }
      },

      toggle(trigger, element, event) {
        if (event) {
          event.preventDefault();
        }

        if (!trigger) {
          trigger = $(`[aria-controls="${this.element.id}"]`)[0];
        }

        if (!element) {
          element = this.element;
        }

        const $this = this;
        const $element = $(element);
        let newHeight = '';
        let newLink = '';
        let expanded = false;
        const collapsedHeight = $element.data('collapsedHeight');

        if ($element.height() <= collapsedHeight) {
          newHeight = `${$element.data('expandedHeight')}px`;
          newLink = 'lessLink';
          expanded = true;
        } else {
          newHeight = collapsedHeight;
          newLink = 'moreLink';
        }

        // Fire beforeToggle callback
        // Since we determined the new "expanded" state above we're now out of sync
        // with our true current state, so we need to flip the value of `expanded`
        $this.options.beforeToggle(trigger, element, !expanded);

        $element.css({ height: newHeight });

        // Fire afterToggle callback
        $element.on('transitionend', function () {
          $this.options.afterToggle(trigger, element, expanded);

          $(this)
            .attr({
              'aria-expanded': expanded,
            })
            .off('transitionend');
        });

        $(trigger).replaceWith(
          $($this.options[newLink])
            .on('click', function (event) {
              $this.toggle(this, element, event);
            })
            .attr({
              'data-readmore-toggle': '',
              'aria-controls': $element.attr('id'),
            }),
        );
      },

      destroy() {
        $(this.element).each(function () {
          const current = $(this);

          current
            .attr({
              'data-readmore': null,
              'aria-expanded': null,
            })
            .css({
              maxHeight: '',
              height: '',
            })
            .next('[data-readmore-toggle]')
            .remove();

          current.removeData();
        });
      },
    };

    $.fn.readmore = function (options) {
      const args = arguments;
      const { selector } = this;

      options = options || {};

      if (typeof options === 'object') {
        return this.each(function () {
          if ($.data(this, `plugin_${readmore}`)) {
            const instance = $.data(this, `plugin_${readmore}`);
            instance.destroy.apply(instance);
          }

          options.selector = selector;

          $.data(this, `plugin_${readmore}`, new Readmore(this, options));
        });
      }
      if (
        typeof options === 'string' &&
        options[0] !== '_' &&
        options !== 'init'
      ) {
        return this.each(function () {
          const instance = $.data(this, `plugin_${readmore}`);
          if (
            instance instanceof Readmore &&
            typeof instance[options] === 'function'
          ) {
            instance[options].apply(
              instance,
              Array.prototype.slice.call(args, 1),
            );
          }
        });
      }
    };
  })(jQuery);

  $('.mr-readmore').each((idx, element) => {
    const customReadMeText = $(element)?.data('readme-text');
    let settings = {
      collapsedHeight: $(window).width() < 767 ? 100 : 120,
    };

    if (window.template_type == 'product') {
      settings = {
        collapsedHeight: 95,
        lessLink: `<a href="#">close</a>`,
      };
    }

    if (customReadMeText != undefined) {
      settings = {
        collapsedHeight: 95,
        moreLink: `<a href="#">${customReadMeText}</a>`,
      };
    }

    $('.mr-readmore').readmore(settings);
  });
};

export default readMore;
